import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue';

Vue.component('vue-recaptcha', VueRecaptcha);

const url = `https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=ru`
const $el = document.createElement('script')
$el.src = url
$el.async = true
document.head.appendChild($el)